import { isAxiosError } from 'axios';

interface ErrorWithConfig {
  config?: { url?: string };
  message?: string;
  response?: unknown;
  code?: string;
}

function isErrorWithConfig(error: unknown): error is ErrorWithConfig {
  return (
    typeof error === 'object' &&
    error !== null &&
    ('config' in error ||
      'message' in error ||
      'response' in error ||
      'code' in error)
  );
}

export const shouldReportError = (error: unknown) => {
  if (!isErrorWithConfig(error)) {
    return true;
  }
  // Do not report weavr incorrect passcode error
  if (
    error?.config?.url === 'weavr/step-up/verify/' &&
    error?.message === 'Request failed with status code 409'
  ) {
    return false;
  }
  // Network and timeout errors are already reported with enriched context
  // by the networkErrorInterceptor in axios.ts
  if (
    (!error?.response && error?.message === 'Network Error') ||
    error?.code === 'ECONNABORTED'
  ) {
    return false;
  }
  if (isAxiosError(error) && error.response?.status === 404) {
    return false;
  }
  return true;
};
